import { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setApplicationSelected } from "@store/slices/componentsSlice";

export default function WhiteZone(props: Partial<{ error: boolean }>) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setApplicationSelected());
    }, []);
    return (
        <Box
            sx={{
                width: "100wh",
                textAlign: "center"
            }}>
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: 100
                }}>
                Oops!
            </Typography>
            <Typography variant="h4" sx={{
                fontWeight: 600
            }}>
                {props.error
                    ? "Ocurrio un error al procesar la información"
                    : "Sin permisos para acceder a la información de esta solicitud"}
            </Typography>
            <Button
                variant="contained"
                onClick={() => (props.error ? navigate(-1) : navigate("/solicitudes"))}
                sx={{ mt: 4 }}
            >
                {props.error ? "Regresar" : "Regresar a lista de solicitudes"}
            </Button>
        </Box>
    );
}
